// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SL-z","twoColumnImage":"TL-z"};